const region = "us-east-1";
const origin = window.location.origin;

const prod = {
  appSettingsData: {
    // generate a file format limit of video file
    autoRefreshFrequency: 10000,
    allowedDomain: ["williamslea.com","wilsonelser.com","nortonrosefulbright.com"],
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: "us-east-1",
      userPoolId: "us-east-1_7HRxYDTuq",
      userPoolWebClientId: "1b746iopnmmnnl4bl8rlv8gfi",
    },
    oauth: {
      domain: "wl-idp-pd-web.auth.us-east-1.amazoncognito.com",
      redirectSignIn: `${origin}/auth`,
      redirectSignOut: `${origin}/auth`,
      responseType: "code",
      scope: ["openid", "profile", "email"],
    },
    API: {
      endpoints: [
        {
          name: "Transcribe",
          endpoint: "https://api.transcribe.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type ProdType = typeof prod;
export default prod;
